//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      visiable: false
    }
  },
  computed: {
  },
  props: {
    title: { type: String, default: '提示' },
    cancel: { type: String, default: '取消' },
    confirm: { type: String, default: '确定' },
    tips: { type: String, default: '' },
    content: { type: String, default: '暂无内容' },
    closable: { type: Boolean, default: true },
    subhead: String
  },
  methods: {
    cancleMethod () {
      this.$emit('cancle')
      if (this.closable) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
      this.visiable = false
    },
    open () {
      this.visiable = true
    },
    confirmMethod () {
      this.$emit('confirm')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dialog.vue